import { makeImmutable } from "../../core";
export class WholeOrderPromotionScope {
    constructor(params) {
        this.kind = "WholeOrder";
        this.selector = params.selector;
        makeImmutable(this);
    }
}
